export const SEARCH_BIKES_REQUEST = 'SEARCH_BIKES_REQUEST';
export const SEARCH_BIKES_SUCCESS = 'SEARCH_BIKES_SUCCESS';
export const SEARCH_BIKES_FAILURE = 'SEARCH_BIKES_FAILURE';

export const SEARCH_BIKES_COUNT_REQUEST = 'SEARCH_BIKES_COUNT_REQUEST';
export const SEARCH_BIKES_COUNT_SUCCESS = 'SEARCH_BIKES_COUNT_SUCCESS';
export const SEARCH_BIKES_COUNT_FAILURE = 'SEARCH_BIKES_COUNT_FAILURE';


export const SEARCH_BIKE_BRAND_REQUEST = 'SEARCH_BIKE_BRAND_REQUEST';
export const SEARCH_BIKE_BRAND_SUCCESS = 'SEARCH_BIKE_BRAND_SUCCESS';
export const SEARCH_BIKE_BRAND_FAILURE = 'SEARCH_BIKE_BRAND_FAILURE';


export const SEARCH_BIKE_MODELS_REQUEST = 'SEARCH_BIKE_MODELS_REQUEST';
export const SEARCH_BIKE_MODELS_SUCCESS = 'SEARCH_BIKE_MODELS_SUCCESS';
export const SEARCH_BIKE_MODELS_FAILURE = 'SEARCH_BIKE_MODELS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/constants/search_bikes.constants.js